import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Card,
  Copy,
  Bold,
  Button,
  Icon
} from "app/NativeComponents/common";
import { formatAddress } from "app/NativeActions";
import MailingAddressMore from "./MailingAddressMore";

class AddressItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_options: false
    };
    this.toggleOptions = this.toggleOptions.bind(this);
  }

  toggleOptions(show_options = false) {
    this.setState({
      show_options
    });
  }

  renderSource(mailing_address) {
    const { colors } = this.props;

    let source = "";
    if (mailing_address.main_address) {
      if (mailing_address.custom_owner) {
        source = "Source: Manually Added";
      } else {
        source = "Source: County Records";
      }
    } else {
      if (mailing_address.manual == 1) {
        source = "Source: Manually Added";
      } else {
        source = "Source: Skip Trace";
      }
    }

    return (
      <Copy style={{ fontSize: 12, color: colors.light_text_color }}>
        {source}
      </Copy>
    );
  }

  renderIsMailing(mailing_address) {
    const { token, colors, active_property } = this.props;

    return (
      <Button
        tooltip={
          mailing_address.send_to_address == 1
            ? "This address will be included when mailers are sent."
            : "No mailers will be sent to this address."
        }
        onPress={() => {
          this.props.updateOwnerInfo({
            token: token,
            deal_id: active_property.deal.id,
            owner_mailing_address_id: mailing_address.owner_mailing_address_id,
            type: "toggle_owner_address",
            send_to_address: mailing_address.send_to_address == 1 ? 0 : 1,
            onSuccess: () => {}
          });
        }}
        style={{
          marginTop: 5,
          backgroundColor:
            mailing_address.send_to_address == 1
              ? colors.success_color_muted
              : colors.background_color,
          borderRadius: 15,
          padding: 10,
          paddingTop: 5,
          paddingBottom: 5,
          marginRight: 5
        }}
      >
        <Row>
          <Icon
            icon={
              mailing_address.send_to_address == 1
                ? "check-box"
                : "check-box-outline-blank"
            }
            size={14}
          />
          <Copy style={{ fontSize: 12, marginLeft: 5 }}>
            {mailing_address.send_to_address == 1
              ? "Sending Mail"
              : "Not Sending"}
          </Copy>
        </Row>
      </Button>
    );
  }

  renderOptionsButton(mailing_address) {
    if (!mailing_address.main_address) {
      return (
        <Wrapper
          style={{
            padding: 15,
            paddingLeft: 0,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            tooltip={"More Options"}
            onPress={() => {
              this.toggleOptions(true);
            }}
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Icon icon={"more-vert"} />
          </Button>
        </Wrapper>
      );
    }
  }

  render() {
    const { mailing_address } = this.props;
    const formatted_address = formatAddress({
      address: {
        address: mailing_address.address,
        address2: mailing_address.address2,
        address_city: mailing_address.city,
        address_state: mailing_address.state,
        address_zip: mailing_address.zip
      }
    });

    return (
      <Card style={{ marginBottom: 0 }}>
        <Wrapper>
          <Row>
            <Wrapper style={{ padding: 15, flex: 1 }}>
              <Copy>
                <Bold>{formatted_address.line1}</Bold>
              </Copy>
              <Copy>{formatted_address.line2}</Copy>
              {this.renderSource(mailing_address)}

              <Row>{this.renderIsMailing(mailing_address)}</Row>
            </Wrapper>
            {this.renderOptionsButton(mailing_address)}
          </Row>
        </Wrapper>
        <MailingAddressMore
          {...this.props}
          mailing_address={mailing_address}
          show_options={this.state.show_options}
          toggleOptions={this.toggleOptions}
        />
      </Card>
    );
  }
}

export default AddressItem;
